import React, { useEffect } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomModal,
  InputPlacaVeiculo,
  InputText,
  InputTime,
} from '../../../../../components'
import useModalTransferencia from './ModalTransferenciaState'

export default function ModalTransferenciaEntrega({ onResponse, selectedTp, transferencia }) {
  const { state, localDispatch } = useModalTransferencia()

  useEffect(() => {
    selectedTp && localDispatch.setTp(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    localDispatch.setTransferencia(transferencia)
  }, [transferencia])

  useEffect(() => {
    state.errorMessage && onResponse('Error', state.errorMessage) && localDispatch.resetMessages()
  }, [state.errorMessage])

  useEffect(() => {
    state.transferenciaWasSaved && onResponse('Saved')
  }, [state.transferenciaWasSaved])

  return (
    <CustomModal
      width={600}
      header="Transferência de Entregas"
      isVisible={true}
      onClose={() => onResponse('Close')}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            disabled={state.transferencia.status !== 'Aguardando Transferencia'}
            label="Nome:*"
            marginTop={10}
            value={state.transferencia.transfer_name}
            onChange={value => localDispatch.onFormDataChange('transfer_name', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomCalendar
            marginTop={20}
            disabled={state.transferencia.status !== 'Aguardando Transferencia'}
            label="Data da Partida:*"
            value={state.transferencia.departure_date}
            onChange={value => localDispatch.onFormDataChange('departure_date', value)}
          />
        </div>
        <div className="p-col-6">
          <InputTime
            disabled={state.transferencia.status !== 'Aguardando Transferencia'}
            label="Horário da Partida:*"
            value={state.transferencia.departure_time}
            onChange={value => localDispatch.onFormDataChange('departure_time', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            disabled={state.transferencia.status !== 'Aguardando Transferencia'}
            label="Nome do Motorista:*"
            marginTop={10}
            value={state.transferencia.driver_name}
            onChange={value => localDispatch.onFormDataChange('driver_name', value)}
          />
        </div>
        <div className="p-col-6">
          <InputPlacaVeiculo
            disabled={state.transferencia.status !== 'Aguardando Transferencia'}
            label="Placa do Veículo de Transferência:*"
            marginTop={10}
            value={state.transferencia.vehicle_plate}
            onChange={value => localDispatch.onFormDataChange('vehicle_plate', value)}
          />
        </div>
        <div className="p-col-12">
          <Btn
            isLoading={state.isLoading}
            onClick={() => localDispatch.save(state.transferencia, state.tpId)}
          >
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}
